export { default as CubeOutlineIcon } from './CubeOutlineIcon';
